import type { User } from '@interfaces/user';
import type { RelationUser } from '@pages/accountsDetail/components/newAffiliate';

export const generateClientNameString = (
  user: User | undefined | RelationUser | Record<string, unknown>,
  onlyFirstName?: boolean,
  onlyFirstAndLastName?: boolean,
): string => {
  if (!user || typeof user !== 'object') return '';
  if ('entityName' in user && user.entityName) return String(user.entityName);
  if (!('firstName' in user) || !user.firstName)
    return 'id' in user && user.id ? String(user.id) : '';
  if (onlyFirstAndLastName)
    return [user.firstName, 'lastName' in user ? user.lastName : undefined]
      .filter(Boolean)
      .join(' ');
  return onlyFirstName
    ? String(user.firstName)
    : [
        user.firstName,
        'middleName' in user ? user.middleName : undefined,
        'lastName' in user ? user.lastName : undefined,
      ]
        .filter(Boolean)
        .join(' ');
};
